var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackHomeComplete4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 853,
    viewBox: "0 0 1920 853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1921 0H0V853H1921V0Z",
    fill: "url(#paint0_linear_901_83640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_83640",
    x1: 2267.96,
    y1: 853,
    x2: 1428.26,
    y2: -748.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732532,
    stopColor: "#0C3A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86811,
    stopColor: "#0B6BDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHomeComplete4);
export default __webpack_public_path__ + "static/media/back-home-complete-4.7b5fa084929a2b3d839df0fa8778ae6e.svg";
export { ForwardRef as ReactComponent };